import { render, staticRenderFns } from "./MainWorksSection.vue?vue&type=template&id=20dccd1a&scoped=true&"
import script from "./MainWorksSection.vue?vue&type=script&lang=js&"
export * from "./MainWorksSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dccd1a",
  null
  
)

export default component.exports